module.exports = __webpack_public_path__ + "img/onboarding-step-3.c161c580.png";